import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
    rubro: {display: 'inline-block', width: 200, marginLeft: 8},
    rubro_d: {display: 'inline-block', width: 600, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_rubro = values.rubro

    if (w_rubro===undefined) {
        errors.rubro = ['El campo Código es requerido'];
    }else {
        if (w_rubro === null) {
            errors.rubro = ['El campo Código es requerido'];
        } else {
            w_rubro = w_rubro.trim()
            if (w_rubro === '') {
                errors.rubro = ['El campo Código es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/Rubro`;

const RubroCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Rubro</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS RUBRO">
                    <TextInput
                        label="Código Rubro"
                        source="rubro"
                        formClassName={classes.rubro}
                        placeholder="Ingrese Código Rubro"
                        helperText="Código Rubro"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                    <TextInput
                        label="Descripción Rubro"
                        source="rubro_d"
                        formClassName={classes.rubro_d}
                        placeholder="Ingrese Descripción Rubro"
                        helperText="Descripción Rubro"
                        margin="normal"
                        fullWidth={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default RubroCreate;


